import { render, staticRenderFns } from "./ProductLayoutView.vue?vue&type=template&id=7db6a322&scoped=true"
import script from "./ProductLayoutView.vue?vue&type=script&lang=js"
export * from "./ProductLayoutView.vue?vue&type=script&lang=js"
import style0 from "./ProductLayoutView.vue?vue&type=style&index=0&id=7db6a322&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db6a322",
  null
  
)

export default component.exports